import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { AppShell } from "@/components/AppShell";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

/* Supervisor accountability table — the numbers are the control (spec §8). */
export default function AdminActivityPage() {
  const { t } = useLang();
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));

  const { data, isLoading } = useQuery({
    queryKey: ["supervisor-activity", month],
    queryFn: async () => (await api.get("/admin/supervisor-activity", { params: { month } })).data,
  });

  return (
    <AppShell>
      <div className="space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="text-xl font-semibold tracking-tight">{t("supervisorActivity")}</h1>
          <Input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            data-testid="activity-month-input"
            className="h-9 w-auto"
          />
        </div>

        <div className="overflow-x-auto rounded-xl border border-border bg-card">
          <Table data-testid="supervisor-activity-table">
            <TableHeader>
              <TableRow>
                <TableHead>{t("supervisor")}</TableHead>
                <TableHead className="text-right">{t("totalReviews")}</TableHead>
                <TableHead className="text-right">{t("approvals")}</TableHead>
                <TableHead className="text-right">{t("flags")}</TableHead>
                <TableHead className="text-right">{t("overrides")}</TableHead>
                <TableHead className="text-right">{t("medianSeconds")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading && (
                <TableRow><TableCell colSpan={6} className="py-8 text-center text-muted-foreground">{t("loading")}</TableCell></TableRow>
              )}
              {!isLoading && (data?.rows || []).length === 0 && (
                <TableRow><TableCell colSpan={6} className="py-8 text-center text-muted-foreground">{t("noResults")}</TableCell></TableRow>
              )}
              {data?.rows?.map((r) => (
                <TableRow key={r.supervisorId} data-testid="activity-row">
                  <TableCell className="font-medium">{r.supervisorName}</TableCell>
                  <TableCell className="text-right font-mono tabular-nums">{r.totalReviews}</TableCell>
                  <TableCell className="text-right font-mono tabular-nums">{r.approvals}</TableCell>
                  <TableCell className="text-right font-mono tabular-nums">{r.flags}</TableCell>
                  <TableCell className="text-right font-mono tabular-nums">{r.overrides}</TableCell>
                  <TableCell className="text-right font-mono tabular-nums">
                    {r.medianSecondsToAct != null ? r.medianSecondsToAct : "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </AppShell>
  );
}
